var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"d-flex justify-content-end"},[_c('span',{staticClass:"font-weight-bold font-italic required-text"},[_vm._v("required*")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }